import {FormProvider, useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import qtCloseIcon from '../../../assets/images/qt-close.png';
import {useGetProjectExternalsQuery} from '../../../redux/projects.api';
import {selectWallet} from '../../../redux/wallet.slice';
import ChainSelector from '../../components/chains-selector/chain-selector';
import ConnectModal from '../../components/connect-modal/connect-modal';
import FarmXyzForm from '../../components/farm-xyz-form/farm-xyz-form';
import InvestConfirm from '../../components/invest-confirm/invest-confirm';
import InvestSuccess from '../../components/invest-success/invest-success';
import Wallet from '../../components/wallet/wallet';
import withFrameProvider from '../../hoc/withFrameProwider';
import withSwitchNetwork from '../../hoc/withSwitchNetwork';
import {useAppSelector} from '../../hooks';
import useFrame, {EFrame} from '../../hooks/useFrame';
import './farm-xyz.page.sass';

interface IProps {}

const FarmXyzPage: React.FC<IProps> = () => {
  const {projectId} = useParams<{projectId: string}>();
  const {} = useGetProjectExternalsQuery(projectId);
  const wallet = useAppSelector(selectWallet);
  const methods = useForm({
    defaultValues: {
      amount: '0',
      token: '',
      address: wallet.address,
      email: '',
      fullName: '',
      telegram: '',
      story: '',
    },
  });
  const {frame, closeFrame} = useFrame();
  const frameMap = {
    [EFrame.NONE]: 'div',
    [EFrame.CONNECT_WALLET]: ConnectModal,
    [EFrame.CONFIRM]: InvestConfirm,
    [EFrame.SUCCESS]: InvestSuccess,
  };

  const Frame = frameMap[frame];
  return (
    <FormProvider {...methods}>
      <div className="farm-xyz-page">
        <div className="farm-xyz-page__inner">
          <div className="farm-xyz-page__toolbar">
            {!!wallet.chainId && <ChainSelector projectId={projectId} />}
            <Wallet className="farm-xyz-page__wallet" />
          </div>
          <FarmXyzForm projectId={projectId} isEmbed />

          <div className="farm-xyz-page__link">
            <a href="https://gagarin.world" target="_blank" rel="noreferrer">
              by gagarin.world
            </a>
          </div>
          {frame !== EFrame.NONE && (
            <div className={'farm-xyz-page__frame'}>
              <div className={`farm-xyz-page__frame-inner ${frame === EFrame.SUCCESS && '_full-height'}`}>
                <img
                  src={qtCloseIcon}
                  alt="close"
                  onClick={() => {
                    closeFrame();
                  }}
                />
                <Frame />
              </div>
            </div>
          )}
        </div>
      </div>
    </FormProvider>
  );
};

export default withFrameProvider(withSwitchNetwork(FarmXyzPage));
